'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  cursor: ', ';\n  border-radius: 3px;\n  border: 1px solid #b9c5cd;\n  width: ', ';\n  height: ', ';\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n  background: ', ';\n  font-size: 0;\n  line-height: 0;\n  &:after {\n    position: absolute;\n    left: ', ';\n    top: 4px;\n    content: \'\';\n    border: ', ';\n    border-top: none;\n    border-right: none;\n    width: ', ';\n    height: ', ';\n    opacity: 0;\n    transform: rotate(-45deg);\n    transition: all .2s ease-in-out;\n  }\n'], ['\n  cursor: ', ';\n  border-radius: 3px;\n  border: 1px solid #b9c5cd;\n  width: ', ';\n  height: ', ';\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n  background: ', ';\n  font-size: 0;\n  line-height: 0;\n  &:after {\n    position: absolute;\n    left: ', ';\n    top: 4px;\n    content: \'\';\n    border: ', ';\n    border-top: none;\n    border-right: none;\n    width: ', ';\n    height: ', ';\n    opacity: 0;\n    transform: rotate(-45deg);\n    transition: all .2s ease-in-out;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _theme = require('@hixme-ui/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledFakeCheckbox = _styledComponents2.default.span(_templateObject, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (_ref) {
  var small = _ref.small,
      jumbo = _ref.jumbo;

  if (small) {
    return '15px';
  }
  if (jumbo) {
    return '22px';
  }
  return '18px';
}, function (_ref2) {
  var small = _ref2.small,
      jumbo = _ref2.jumbo;

  if (small) {
    return '15px';
  }
  if (jumbo) {
    return '22px';
  }
  return '18px';
}, function (props) {
  return props.disabled ? '#f9fafb' : 'white';
}, function (_ref3) {
  var small = _ref3.small,
      jumbo = _ref3.jumbo;

  if (small) {
    return '3px';
  }
  if (jumbo) {
    return '5px';
  }
  return '4px';
}, function (props) {
  return props.disabled ? '2px solid #B9C5CD' : '2px solid ' + _theme2.default.colors.primary;
}, function (_ref4) {
  var small = _ref4.small,
      jumbo = _ref4.jumbo;

  if (small) {
    return '8px';
  }
  if (jumbo) {
    return '12px';
  }
  return '9px';
}, function (_ref5) {
  var small = _ref5.small,
      jumbo = _ref5.jumbo;

  if (small) {
    return '4px';
  }
  if (jumbo) {
    return '7px';
  }
  return '5px';
});

exports.default = StyledFakeCheckbox;
//# sourceMappingURL=StyledFakeCheckbox.js.map


//////////////////
// WEBPACK FOOTER
// ../checkbox/lib/StyledFakeCheckbox.js
// module id = 156
// module chunks = 0